import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '@/router'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
   
    // Error Messages
    errors: undefined,

    // Loader Icon
    loader: false,

    listpositions: []

  },
  mutations: {

    STORE_ERRORS (state, errorData) {
      if (errorData.response) {
        console.log('1')
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // Obtain list of all key values in the error object
        state.errors = errorData.response.data
      } else if (errorData.request) {
        console.log('2')          
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        state.errors = {message: 'Network Error'}
      } else {
        console.log('3')          
        // Something happened in setting up the request that triggered an Error
        state.errors = errorData
      }     
    },  
    CLEAR_ERRORS (state) {
      state.errors = undefined
    },
    SET_LOADER(state, payload) {
      state.loader = payload
    },
    STORE_AUTH_USER (state, payload) {
      state.idToken = payload.token
      state.userId  = payload.userId
    },
    CLEAR_AUTH_DATA (state) {
      state.idToken = null
      state.userId  = null
      state.userName = null   
    },    
    CLEAR_STATE (state) {
      state.checklists = []
      state.checklistitems = []  
    },
    STORE_CURRENT_USER (state, payload) {
      state.userName = payload[0].userName
      state.darkTheme = payload[0].darkTheme
    },
    STORE_LIST_POS (state, payload) {
      // Check if an entry already exists in the array for page
      var i = Vue.getIndexByAttr(state.listpositions, 'pagekey', payload.pagekey)
      if (i > -1) {
        // Update
        state.listpositions[i] = payload
      } else {
        // Add
        state.listpositions.push(payload)
      }
    },
    DELETE_LIST_POS (state, payload) {
      Vue.removeByAttr(state.listpositions, 'pagekey', payload)
    },   
    DELETE_LIST_POS_ALL (state) {
      state.listpositions = []
    },         

  },
  actions: {

    setErrorMsg ({commit}, errorData) {
      commit('STORE_ERRORS', errorData)
    },

    clearErrorMsg ({commit}) {
      commit('CLEAR_ERRORS')
    },

    // Store current User ID, Authentication Token and expiry date in local storage
    login ({commit, dispatch}, authData) {
      return new Promise( (resolve, reject) => {
        axios.post('/Account/Login', authData)        
        .then( async (response) => {
             
          localStorage.setItem('token', response.data.token)
          localStorage.setItem('userId', response.data.id)
          localStorage.setItem('expirationDate', response.data.expiryDate);

          resolve(response)
        })
        .catch( (error) => {
          commit('STORE_ERRORS', error)
          reject( error)
        })
      })
    },

    apiPost ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post(data.url, data.payload)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            commit('STORE_ERRORS', error)
            reject(error);
          })
      })
    },

    apiPut ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.put(data.url, data.payload)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            commit('STORE_ERRORS', error)
            reject(error)
          })
      })
    },

    apiGet ({ commit }, endpoint) {
      return new Promise((resolve, reject) => {
        axios.get(endpoint)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            commit('STORE_ERRORS', error)
            reject(error)
          })
      })
    },    

    // Clear Authentication details from both state and local storage
    logout ({commit}) {
      //commit('CLEAR_AUTH_DATA')
      commit('CLEAR_STATE')
      localStorage.removeItem('expirationDate')
      localStorage.removeItem('token')
      localStorage.removeItem('userId')
      localStorage.removeItem('currentRTL')
      localStorage.removeItem('currentLocale')
     
    },    // Check if Authentication Token stored in local storage is still valid

    tryAutoLogin () {
      const token = localStorage.getItem('token')
      if (!token) {
        return router.replace('/signin').catch(err => {}) 
      }
      const expirationDate = localStorage.getItem('expirationDate')
      const now = new Date()
      if (now >= expirationDate) {
        return router.replace('/signin').catch(err => {}) 
      }
      // const userId = localStorage.getItem('userId')
      // commit('STORE_AUTH_USER', {
      //   token: token,
      //   userId: userId
      //})
      return router.replace('/tasks').catch(err => {}) 
    },


    setListPosition( {commit}, pageData ) {
      commit('STORE_LIST_POS', pageData)
    },

    getListPosition( {state}, pagekey) {
      // Check if entry is already in the  array, if so, what is the position
      var i = Vue.getIndexByAttr(state.listpositions, 'pagekey', pagekey)
      if (i > -1) {
        // Found
        return '#' + state.listpositions[i].listpos
      } else {
        return null
      }

    },

    deleteListPosition( {commit}, pagekey ) {
      commit('DELETE_LIST_POS', pagekey)
    },    

    deleteListPositionAll( {commit} ) {
      commit('DELETE_LIST_POS_ALL')
    },                
  },
  modules: {
  }
})
